import { getMsg, detectLevel } from "../../utils";
import { getAuditFields, formatAuditCell } from "./audit";

function tokenize(q) {
  return (q || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
}

function norm(s) {
  return (s ?? "").toString().toLowerCase();
}

export function filterRows(rows, query) {
  const tokens = tokenize(query);
  if (tokens.length === 0) return rows;

  // 👉 action: OR, alles andere AND
  const actionFilters = [];
  const restTokens = [];

  for (const t of tokens) {
    const m = t.match(/^(\w+):(.+)$/);
    if (m && m[1].toLowerCase() === "action") {
      actionFilters.push(norm(m[2]));
    } else {
      restTokens.push(t);
    }
  }

  return rows.filter((row) => {
    const msgRaw = getMsg(row) || "";
    const msg = norm(msgRaw);
    const lvl = norm(detectLevel(msgRaw));

    const audit = formatAuditCell(getAuditFields(row));
    const action = norm(audit.action);
    const host = norm(audit.hostCodeMasked);
    const user = norm(audit.actorUsername);

    /* ---------- ACTION: OR ---------- */
    if (actionFilters.length > 0) {
      const ok = actionFilters.some((a) => action.startsWith(a));
      if (!ok) return false;
    }

    /* ---------- REST: AND ---------- */
    return restTokens.every((t) => {
      const token = norm(t);

      const m = token.match(/^(\w+):(.+)$/);
      if (m) {
        const key = m[1];
        const val = m[2];

        if (key === "level") {
          return (
            lvl === val ||
            (val === "error" && (lvl === "error" || lvl === "fatal"))
          );
        }
        if (key === "user") return user.startsWith(val);
        if (key === "host") return host.startsWith(val);
        if (key === "msg") return msg.includes(val);

        // unbekannter key → freier Text
        return (
          msg.includes(token) ||
          action.includes(token) ||
          host.includes(token) ||
          user.includes(token)
        );
      }

      // freier Text
      return (
        msg.includes(token) ||
        action.includes(token) ||
        host.includes(token) ||
        user.includes(token)
      );
    });
  });
}
